'use client';

import { createContext } from 'react';
import type { UseAppUiThemeReturnValues } from './types';

export const AppUiThemeContext = createContext<
  UseAppUiThemeReturnValues | undefined
>(undefined);
